export enum StorageKeys {
  AuthData = '@authData',
  Calculator = '@calculator',
  CallbackUrl = '@callbackUrl',
  CustomToken = '@customToken',
}
